export interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  errors?: Record<string, string[]>;
}

export class ApiError extends Error {
  public readonly status: number;
  public readonly problemDetails: ProblemDetails | null;

  public constructor(status: number, problemDetails: ProblemDetails | null) {
    super(problemDetails?.title ?? `Request failed with status ${status}`);
    this.name = "ApiError";
    this.status = status;
    this.problemDetails = problemDetails;
  }
}

/** First message of each field of a validation response, keyed by the camelCase field name; empty for other errors. */
export function readFieldErrors(error: unknown): Record<string, string> {
  const problemErrors = error instanceof ApiError && error.status === 400 ? (error.problemDetails?.errors ?? {}) : {};
  const fieldErrors = Object.fromEntries(
    Object.entries(problemErrors).flatMap(([fieldName, messages]) => {
      const firstMessage = messages.at(0);

      return firstMessage !== undefined && fieldName !== "" ? [[toCamelCase(fieldName), firstMessage]] : [];
    }),
  );

  return fieldErrors;
}

function toCamelCase(fieldName: string): string {
  const camelCaseName = `${fieldName.charAt(0).toLowerCase()}${fieldName.slice(1)}`;

  return camelCaseName;
}
